module.exports = __webpack_public_path__ + "static/media/mtto_urgente.d378583d.svg";